// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"_1936eo aLs3Nr","top":"_2cNyQv","mobileFooter":"_2ACVA0","soMe":"_3ivYWu"};